import { z } from 'zod'
import { zId, zIdNullable } from '../common'
import { zAdminRole } from '../enums'

export const zAdmin = z.object({
  id: zId,
  email: z.string(),
  role: zAdminRole,
  tenantId: zIdNullable,
})
export type Admin = z.infer<typeof zAdmin>

export const zSession = z.object({
  token: z.string(),
  admin: zAdmin,
})
export type Session = z.infer<typeof zSession>
